import { useCallback, useRef } from 'react';
import { testMediaConnectionBitrate, MediaConnectionBitrateTest } from '@twilio/rtc-diagnostics';
import { ACTIONTYPE } from '../AppStateProvider';

export default function useBitrateTestTCP(dispatch: React.Dispatch<ACTIONTYPE>) {
  const bitrateTestRef = useRef<MediaConnectionBitrateTest>();
  const startBitrateTCPTest = useCallback(() => {
    //Don't start a new bitrate test if one is already running:
    if (bitrateTestRef.current) {
      return;
    }

    if (!process.env.REACT_APP_TURN_SERVER_URL_TCP) {
      dispatch({ type: 'tcp-set-bitrate-test-disabled' });
      return;
    }

    dispatch({ type: 'tcp-set-bitrate-test-enabled' });
    dispatch({ type: 'tcp-bitrate-test-started' });

    return new Promise(() => {
      const bitrateTest = testMediaConnectionBitrate({
        iceServers: [
          {
            urls: [process.env.REACT_APP_TURN_SERVER_URL_TCP!],
            username: process.env.REACT_APP_TURN_SERVER_USERNAME,
            credential: process.env.REACT_APP_TURN_SERVER_PASSWORD,
          },
        ],
      });

      bitrateTestRef.current = bitrateTest;

      bitrateTest.on(MediaConnectionBitrateTest.Events.Bitrate, (bitrate) => {
        dispatch({ type: 'tcp-set-bitrate', bitrate });
      });

      bitrateTest.on(MediaConnectionBitrateTest.Events.Error, (error) => {
        dispatch({ type: 'tcp-set-bitrate-test-error', error });
        dispatch({ type: 'tcp-bitrate-test-finished' });
      });

      bitrateTest.on(MediaConnectionBitrateTest.Events.End, (report) => {
        dispatch({ type: 'tcp-set-bitrate-test-report', report });
        dispatch({ type: 'tcp-bitrate-test-finished' });
      });

      setTimeout(() => {
        bitrateTest.stop();
      }, 5000);
    }).catch((error) => {
      dispatch({ type: 'tcp-set-bitrate-test-error', error });
      dispatch({ type: 'tcp-bitrate-test-finished' });
    });
  }, [dispatch]);

  return startBitrateTCPTest;
}
